<template>
  <div class="yqz-content">
    <div
      class="card-list"
      v-if="vStatus==0"
      element-loading-background="rgba(0, 0, 0, 0.1)"
      v-loading="dLoading">
      <template v-for="(item, index) in personList">
      <div class="yq-card-item" :key="index" @click="showMode(item)">
        <div class="equip-item-top">
          <el-col :span="6">
            <div class="equip-imag">
                    <template v-if="item.status == 0||item.status == 1||item.status == 2">
                      <div class="img-icon3">
                        <img :src="item.photoLink" alt />
                      </div>
                      <p class="state3" style="margin-top: 8px">
                        <span class="yuandian"></span>
                        <span>在库</span>
                      </p>
                    </template>
                    <template v-if="item.status == 3">
                      <div class="img-icon3">
                        <img :src="item.photoLink" alt />
                      </div>
                      <p class="state3" style="margin-top: 8px">
                        <span class="yuandian"></span>
                        <span>管理员取出</span>
                      </p>
                    </template> 
                    <template v-if="item.status == 6||item.status == 4||item.status == 5">
                      <div class="img-icon2">
                        <img :src="item.photoLink" alt />
                      </div>
                      <p class="state2" style="margin-top: 8px">
                        <span class="yuandian"></span>
                        <span>借出</span>
                      </p>
                    </template>
                    
                    
                  </div>
          </el-col>
          <el-col :span="18">
            <div class="equip-detail">
              <div class="items">
                <span>{{ item.instrumentName }}</span>
              </div>
              <div class="items tow-columns">
                <div class="left_item">
                  <span>编号：</span>
                  <span>{{ item.serialNumber }}</span>
                </div>
                <div class="rigth_item">
                  <span>型号：</span>
                  <span>{{ item.pattern }}</span>
                </div>
              </div>
              <div class="items tow-columns">
                <div class="left_item">
                  <span>位置：</span>
                  <span v-if="item.address">{{ item.address }}</span>
                  <span v-else-if="item.boxIndex">格口{{ item.boxIndex }}</span>
                  <span v-else>{{ item.shelfName }}-{{ item.storeName }}</span> 
                </div>
              <div class="rigth_item" v-if="item.status == 4||item.status==5">
                      <span>借出人：</span>
                      <span>{{ item.borrower }}</span>
                    </div>
                  </div>
              <div class="iconf-letf">
                <span @click.stop="maintainClick(item)">
                    <i style="font-size: 18px;" class="iconfont icon-baoyang"></i>
                  </span>
                &nbsp;
                <span @click.stop="testClick(item)">
                    <i style="font-size: 18px;" class="iconfont icon-jiandingdan"></i>
                  </span>
                &nbsp;
                <span @click.stop="exportClick(item)">
                    <i style="font-size: 18px;" class="iconfont icon-wendang"></i>
                </span>
                &nbsp;
                <span @click.stop="editClick(item)">
                    <i style="font-size: 18px;" class="iconfont icon-bianji1"></i>
                  </span>
                  &nbsp; 
                    <span @click.stop="outPut(item)">
                      <i style="font-size: 18px;" class="el-icon-document-copy"></i>
                    </span>
              </div>
            </div>
          </el-col>
        </div>
        <div class="equip-item-bottom">
          <div class="row-item">
            <div class="left_item1">
              <span>厂家：</span>
              <span>{{ item.factoryName }}</span>
            </div>
            <div class="right_item1">
              <span>价钱：</span>
              <span>{{ item.prize?item.prize:"暂无" }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="left_item2">
              <span>出厂日期：</span>
              <span>{{ item.produceTime }}</span>
            </div>
            <div class="right_item2">
              <span>启用时间：</span>
              <span>{{ item.startUpTime }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="left_item2">
              <span>精度：</span>
              <span>{{ item.precision }}</span>
            </div>
            <div class="rigth_item">
              <span>检定有效期：</span>
              <span>{{ item.validityEffectiveTime }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="left_item2">
              <span>量程：</span>
              <span>{{ item.range }}</span>
            </div>
            <div class="rigth_item">
              <span>保养有效期：</span>
              <span>{{ item.maintenanceEffectiveTime }}</span>
            </div>
          </div>
          <div class="row-item dibu" @click.stop="statesChange(item)">
            <template v-if="item.states == 0">
                  <span class="state1">
                    <i class="iconfont icon-zhengchang"></i>
                    <span>正常</span>
                  </span>
            </template>
            <template v-if="item.states == 1">
                  <span class="state3">
                    <i class="iconfont icon-jiangji"></i>
                    <span>降级</span>
                  </span>
            </template>
            <template v-if="item.states == 2">
                  <span class="state2">
                    <i class="iconfont icon-tingyong_line"></i>
                    <span>停用</span>
                  </span>
            </template>
            <template v-if="item.states == 3">
                  <span class="state2">
                    <i class="iconfont icon-weixiu"></i>
                    <span>需维修</span>
                  </span>
            </template>
            <template v-if="item.states == 4">
                  <span class="state3">
                    <i class="iconfont icon-shebeijiandingshiyongren"></i>
                    <span>需检定</span>
                  </span>
            </template>
            <template v-if="item.states == 5">
                  <span class="state3">
                    <i class="iconfont icon-icon"></i>
                    <span>需保养</span>
                  </span>
            </template>
            <template v-if="item.states == 6">
                  <span class="state3">
                    <i class="iconfont icon-icon"></i>
                    <span>报废</span>
                  </span>
            </template>
            <template v-if="item.isNeedPower == 0 && item.isCharger">
                  <span class="state1" @click.stop="mandian">
                    <i class="iconfont icon-battery-full"></i>满电
                  </span>
            </template>
            <template v-if="item.isNeedPower == 1 && item.isCharger">
                  <span class="state3" @click.stop="recharge(item)">
                    <i class="iconfont icon-juxingcopy"></i>充电
                  </span>
            </template>
         
          </div>
        </div>
      </div>
</template>
    </div>
    <div class="table-list sysTable-w" v-else>
      <el-table
      :row-key="getRowKeys" ref="multipleTable" 
      @selection-change="handleSelectionChange" 
      
        :data="personList"
        row-key="id"
        height="740"
        element-loading-background="rgba(0, 0, 0, 0.1)"
        v-loading="dLoading"
        :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
        style="width: 100%">
        <el-table-column type="selection" width="55" :reserve-selection="true" />
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          align="left"
          prop="instrumentName"
          label="仪器名称"
          show-overflow-tooltip
          min-width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="serialNumber"
          label="编号"
          show-overflow-tooltip
          min-width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="pattern"
          label="型号"
          show-overflow-tooltip
          min-width="150">
        </el-table-column>
        <el-table-column align="center"  label="资产类型" show-overflow-tooltip min-width="200">
                <template slot-scope="scope">
                  {{scope.row.assetType==1?'固定资产':scope.row.assetType==2?'非固定资产':'-'}}
                </template>
            </el-table-column>
            
        <el-table-column
          align="center"
          prop="boxIndex"
          label="位置"
          min-width="120">
          <template slot-scope="scope">
                <template v-if="scope.row.address">
                  {{ scope.row.address }}
                </template>
                <template v-else-if="scope.row.boxIndex">
                  格口{{scope.row.boxIndex}}
                </template>
                <template v-else>
                  <span>{{ scope.row.shelfName }}-{{ scope.row.storeName }}</span>
                </template>
              </template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="在库状态" width="150">
              <template slot-scope="scope">
                <div style="cursor: pointer;">
                  <template v-if="scope.row.status == 0||scope.row.status == 1||scope.row.status == 2">
                    <p class="state3" style="margin-top: 8px">
                      <span class="yuandian"></span>
                      <span>在库</span>
                    </p>
                  </template>
                 
                  <template v-if="scope.row.status == 3">
                    <p class="state3" style="margin-top: 8px">
                      <span class="yuandian"></span>
                      <span>管理员取出</span>
                    </p>
                  </template>
                  <template v-if="scope.row.status == 4||scope.row.status == 6||scope.row.status == 5">
                    <p class="state2" style="margin-top: 8px">
                      <span class="yuandian"></span>
                      <span>借出</span>
                    </p>
                  </template>
                 
                </div>
              </template>
            </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button @click="showMode(scope.row)" type="text" size="small">详情</el-button>
            <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
            &nbsp;&nbsp;
            <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a" >
                  <span @click="exportClick(scope.row)">使用</span>
                </el-dropdown-item>
                <el-dropdown-item command="b">
                  <span @click="maintainClick(scope.row)">保养</span>
                </el-dropdown-item>
                <el-dropdown-item command="c">
                  <span @click="testClick(scope.row)">检定</span>
                </el-dropdown-item>
                <el-dropdown-item command="d">
                    <span @click="outPut(scope.row)">出入库</span>
                  </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 详情弹框内容 -->
    <div v-if="dialogVisible" class="popout model">
      <el-dialog title="详细信息" :visible.sync="dialogVisible" width="1500px" v-alterELDialogMarginTop="{marginTop:'6vh'}">
        <equip-model
          :message="particular"
          @deleteItem="deleteItem"
        ></equip-model>
      </el-dialog>
    </div>
    <!-- 编辑数据弹框 -->
    <div class="popout model">
      <el-dialog
        class="popout model"
        title="修改数据"
        :visible.sync="posp"
        width="1000px"
        append-to-body
        :close-on-click-modal="false"
      >
        <redactModel
          v-if="posp"
          :itemData="particular"
          @editingInstrument="editingInstrument"
        ></redactModel>
      </el-dialog>
    </div>
    <!-- 导出弹框 -->
    <el-dialog
      title="仪器设备使用记录"
      :visible.sync="exPosp"
      width="1350px"
      center
      v-alterELDialogMarginTop="{marginTop:'5vh'}"
      append-to-body>
      <exportModel :insId="particular.id"  :itemData="particular" :exPosp="exPosp"></exportModel>
    </el-dialog>

    <!-- 状态修改弹框 -->
    <el-dialog title="状态修改" v-if="sVisible" :visible.sync="sVisible" width="380px">
      <statue-model @statusOk="statusOk" @statusCancel="statusCancel" :status-modal="statusModal"></statue-model>
    </el-dialog>

    <!-- 检定弹框 -->
    <div>
      <el-dialog title="检定记录" center :visible.sync="jdVisible" width="85%">
        <jd-table-pop-model :data-model="jdPopData" v-if="jdVisible"></jd-table-pop-model>
      </el-dialog>
    </div>
    <!-- 保养弹框 -->
      <el-dialog title="保养记录" center :visible.sync="byVisible" width="1450px">
        <by-table-pop-model :data-model="byPopData" v-if="byVisible"></by-table-pop-model>
      </el-dialog>
       <!-- 出入库记录弹框 -->
       <el-dialog title="出入库记录" center  :visible.sync="outPutVisible" width="1500px">
        <out-put-pop-model :data-model="outPutData" v-if="outPutVisible" />
      </el-dialog>

  </div>
</template>
<script>
import {
  delectInstrument,
   getVerify, getMainta, changeStatus, changeStates, ChangePowerStates,createInstrument 
} from "@/api/depotApi";
import equipModel from "./equipModel1";
import redactModel from "@/components/redactModel";
import exportModel from "../../components/exportModel";
import byTablePopModel from "../../components/byTablePopModel";
import jdTablePopModel from "../../components/jdTablePopModel";
import outPutPopModel from "../../components/outPutPopModel.vue";
import statueModel from "../../components/statueModel.vue";
export default {
  props: {
    yqz: Object,
    dataList: Array,
    vStatus:Number,
    dLoading:Boolean
  },
  name: "yqzComponen",
  components: {
    statueModel,
    equipModel,
    redactModel,
    exportModel,
    byTablePopModel,
    jdTablePopModel,
    outPutPopModel
  },
  data() {
    return {
      getRowKeys(row){
        return row.id
      },
      multipleSelection: [],
      addModel: false,
      dialogVisible: false,
      currentPage: 1, //当前页数
      pageSize: 5, //页数
      total: 0, //总数
      // personList: [],
      particular: {}, //传给弹框数据
      posp:false,//编辑弹框
      exPosp:false,//导出弹框
      byVisible: false,
      jdVisible: false,
      sVisible: false, //修改状态
      statusModal: {
        id: "",
        status: "",
      },
      outPutVisible: false,
      outPutData :{},
      jdPopData: {}, //传参
      byPopData: {}, //传参
    };
  },
  created() {
 
  },
  computed: {
    personList() {
      return this.dataList;
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val.map(it => it.id);
      this.$emit('update',this.multipleSelection)
    },
    clearMultipleSelection(){
      this.multipleSelection  = []
      this.$refs.multipleTable.clearSelection();
    },
    statesChange(val) {
      let self = this;
      self.statusModal.id = val.id;
      self.$set(self.statusModal, "states", val.states);
      // self.statusModal.states = val.states;
      self.statusModal.type = "states";
      self.sVisible = true;
    },
    /***充电状态时可点击改变成满电状态 */
    recharge(item) {
      ChangePowerStates({ insId: item.id }).then((res) => {
        this.$message({
          type: "success",
          message: "充电成功",
        });
        item.isNeedPower = 0;
      });
    },
    mandian() {},
    statusOk(data) {
      let self = this;
      if (self.statusModal.type == "status") {
        let data = {
          insId: self.statusModal.id,
          status: self.statusModal.status,
        };
        changeStatus(data).then((res) => {
          self.$message({
            type: "success",
            message: res.msg,
          });
          self.$emit("sChange", {});
        });
       
      } else {
        changeStates({...data}).then((res) => {
          self.$message({
            type: "success",
            message: res.msg || "操作成功！",
          });
          self.$emit("sChange", {});
        });
      }
      self.sVisible = false;
    },
    statusCancel() {
      this.sVisible = false;
    },
    showMode(item) {
      this.particular = item;
      this.$store.dispatch("setInstrument", item);
      this.dialogVisible = true;
    },
    dispose() {
      console.log("消息处置");
      this.$store.dispatch("setUpdateInstr", "true");
    },
    deleteItem(id) {
      let that = this;
      //删除数据
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delectInstrument({ id: id }).then((res) => {
            if (res.code == 200) {
              that.dialogVisible = false;
              that.$message({
                type: "success",
                message: "删除成功",
              });
              that.$emit("information", "dele");
            } else {
              this.$message.error(res.msg || "仪器删除失败！");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //分页功能
    pageChange(page) {
      this.currentPage = page;
      // this.acquire();
      this.$emit("information", "");
    },
    editClick(item) {
      this.particular = item;
      this.posp = true;
    },
   
    editingInstrument(data) {
      if(data=='cancel'){
        this.posp = false;
        return
      }
      let params = {
        ...data,
      };
      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === null) {
          delete params[key];
        }
        if (key === "resultPicFile") {
          delete params[key];
        }
      });
      createInstrument(params)
        .then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$store.dispatch("setInstrument", res.data);
            this.$store.dispatch("setUpdateInstr", "true");
            this.posp = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("提交失败，请重新提交");
        });
    },
    exportClick(val){
      let self = this;
      self.particular = val;
      self.exPosp = true;
    },
    maintainClick(item){
      this.byPopData = item;
      this.byVisible = true;
    },
    testClick(item){
      this.jdPopData = item;
      this.jdVisible = true;
    },
    outPut(item){
      this.outPutData = item;
      this.outPutVisible = true;
    },
    byChange(operation, data) {
      if (operation) {
        getMainta(data).then((res) => {
          this.$message({
            message: "处理成功",
            type: "success",
          });
          this.mainIndex = 1;
          this.maintainList = [];
          this.$emit("information", "");
          this.byVisible = false;
        });
      } else {
        this.byVisible = false;
      }
    },
    jdChange(operation, data) {
      if (operation) {
        getVerify(data).then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "处理成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.verificaIndex = 1;
          this.verification = [];
          this.$emit("information", "");
          this.jdVisible = false;
        });
      } else {
        this.jdVisible = false;
      }
    },
  },
};
</script>

<style lang='less' scoped>
@import "~@/assets/css/commonStyle.less";
@import "~@/assets/css/myTableStyle.less";
.yqz-content {
  width: 100%;
  .card-list {
    width: 100%;
    margin-top: 10px;
    height: 740px;
    // display: flex;
    .yq-card-item {
      width: 32.3333%;
      float: left;
      box-sizing: border-box;
      margin-bottom: 10px;
      margin-left: 1%;
      height: 350px;
      border: 2px solid#0090F0;
      box-shadow: 0 0 33px#0090F0 inset;
      border-radius: 4px;
      .equip-item-top {
        width: 100%;
        height: 40%;
        background: linear-gradient(
          180deg,
          rgba(0, 210, 255, 0.52),
          rgba(0, 57, 142, 0.52)
        );
        .equip-imag {
          height: 100%;
          width: 100%;
          text-align: center;
        }
        .equip-detail {
          position: relative;
          .items {
            height: 30px;
            line-height: 30px;
            color: #74c8fe;
            /*line-height: 75%;*/
            font-size: 16px;
            margin-top: 10px;
            margin-left: 10px;
          }
          .tow-columns {
            display: flex;
            justify-content: space-between;
            color: #74c8fe;
            /*line-height: 75%;*/
            font-size: 16px;
            margin-top: 10px;
            margin-left: 10px;
            .left_item {
              width: 50%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .rigth_item {
              width: 50%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .iconf-letf {
            position: absolute;
            right: 10px;
            top: -0px;
            cursor: pointer;
            i {
              font-size: 24px;
              color: #74c8fe;
            }
          }
        }
      }
      .equip-item-bottom {
        width: 100%;
        height: 60%;
        background: rgba(8, 19, 41, 0.5);
        box-shadow: 0 0 15px #0071f1 inset;
        padding: 2% 4%;
        box-sizing: border-box;
        .row-item {
          color: #74c8fe;
          font-size: 16px;
          height: 38px;
          line-height: 38px;
          align-items: center;
          justify-content: space-between;
          .left_item {
            display: inline-block;
            width: 30%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .rigth_item {
            display: inline-block;
            min-width: 220px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .left_item1 {
            display: inline-block;
            width: 70%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .right_item1 {
            display: inline-block;
            width: 28%;
            text-align: right;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .left_item2 {
            display: inline-block;
            width: 41%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .right_item2 {
            display: inline-block;
            width: 49%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .dibu {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          i {
            margin-right: 4px;
          }
        }
      }
    }
    .add-item {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .resource-block {
    clear: both;
    text-align: center;
    margin-top: 30px;
  }
}
/deep/ .el-dialog__body{
  padding-top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/yqz/yqzcomponents.vue